import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { ApiService } from "./api.service";
import Raven from 'raven-js';

@Injectable()
export class DataService {
  housingCategories: Promise<any>;
  jobCategories: Promise<any>;
  jobBranches: Promise<any>;
  saleCategories: Promise<any>;
  helpCategories: Promise<any>;

  constructor(private _apiService: ApiService) {

    let reportErrorToRaven = (requestType) => {
      return (err) => {
        Raven.captureMessage(err, {
          extra: {
            location: 'data-service',
            request: requestType
          }
        });
      };
    };


    this.housingCategories = new Promise((resolve) => {
      this._apiService.getHousingCategories().then(res => {
        resolve(res.objects);
      }).catch(reportErrorToRaven('getHousingCategories'));
    });

    this.jobCategories = new Promise((resolve) => {
      this._apiService.getJobCategories().then(res => {
        resolve(res.objects);
      }).catch(reportErrorToRaven('getJobCategories'));
    });

    this.jobBranches = new Promise((resolve) => {
      this._apiService.getJobBranches().then(res => {
        resolve(res.objects);
      }).catch(reportErrorToRaven('getJobBranches'));
    });

    this.saleCategories = new Promise((resolve) => {
      this._apiService.getSaleCategories().then(res => {
        resolve(res.objects);
      }).catch(reportErrorToRaven('getSaleCategories'));
    });

    this.helpCategories = new Promise((resolve) => {
      this._apiService.getHelpCategories().then(res => {
        resolve(res.objects);
      }).catch(reportErrorToRaven('getHelpCategories'));
    });
    this.getCategoryByURI('/api/v1/housing_category/1/');
  }

  getCategoryByURI(uri) {
    return new Promise((resolve) => {
      Promise.all([this.housingCategories, this.jobCategories, this.jobBranches, this.saleCategories, this.helpCategories]).then(values => {
        resolve([].concat.apply([], values).find(c => c.resource_uri === uri));
      });
    })
  }
}



// WEBPACK FOOTER //
// ./src/providers/data-service.ts